'use client';

import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';

import { GetWorkGroup_V1Query } from '@lichtblick/types';

import { WorkItemCard } from './WorkItemCard';
import { Container, ListContainer } from './WorkItemCardList.styles';

export type WorkItemCardListProps = {
  initalItemId: string;
  workGroup?: GetWorkGroup_V1Query['getWorkGroup_V1']['data'];
};

export const WorkItemCardList = ({ initalItemId, workGroup }: WorkItemCardListProps) => {
  const [currentItem, setCurrentItem] = useState<string>(initalItemId);
  const currentItemRef = useRef<HTMLDivElement | null>(null);
  const workItems = workGroup?.items;

  useEffect(() => {
    if (currentItemRef.current?.scrollIntoView) {
      currentItemRef.current?.scrollIntoView();
    }
  }, [currentItemRef]);

  const onClick = (id: string) => {
    setCurrentItem(id);
  };

  return (
    <Container>
      <ListContainer>
        {workItems?.map((workItem) => (
          <div data-testid="card-container" key={workItem.id} onClick={() => onClick(workItem.id)}>
            <Link href={`${workItem.id}`}>
              <WorkItemCard
                isSelected={currentItem === workItem.id.toString()}
                name={workItem.name ?? ''}
                ref={currentItem === workItem.id.toString() ? currentItemRef : null}
                status={workItem.approvalState}
              />
            </Link>
          </div>
        ))}
      </ListContainer>
    </Container>
  );
};
